import { Component, Input } from '@angular/core';
import { GeneralLiabilityResponse } from '../../../../../models/api/view/claim/details/general-liability/general-liability-response';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-property-gl',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    AddressLabelComponent,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
      <app-card label="Injured/Owner" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.propertyDamage">
          <app-detail-item label="Name" name="name" />
          <app-detail-item label="Address" name="address">
            <ng-template #value let-data>
              <app-address-label
                [street1]="data.address"
                [city]="data.city"
                [state]="data.state"
                [postalCode]="data.zip"
                [country]="data.country === 'USA' ? null : data.country"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Home phone" name="homePhone" format="p" />
          <app-detail-item label="Work phone" name="workPhone" format="p" />
          <app-detail-item label="Cell phone" name="cellPhone" format="p" />
          <app-detail-item label="Age" name="age" />
          <app-detail-item label="Sex" name="sex" />
          <app-detail-item label="Occupation" name="occupation" />
        </app-detail-panel>
      </app-card>
      <app-card label="Employer" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.employer">
          <app-detail-item label="Name" name="name" />
          <app-detail-item label="Address" name="address">
            <ng-template #value let-data>
              <app-address-label
                [street1]="data.address"
                [city]="data.city"
                [state]="data.state"
                [postalCode]="data.zip"
                [country]="data.country === 'USA' ? null : data.country"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Where taken" name="whereTaken" />
          <app-detail-item
            label="What was injured doing"
            name="whatWasInjuredDoing"
          />
          <app-detail-item label="When to see" name="whenToSee" />
          <app-detail-item
            label="Estimated amount"
            name="estimatedAmount"
            format="c"
          />
          <app-detail-item
            label="Other insurance"
            name="otherInsurance"
            format="b"
          />
          <app-detail-item
            label="Reported to carrier"
            name="reportedToCarrier"
            format="b"
          />
          <app-detail-item label="Carrier name" name="carrierName" />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class PropertyGlComponent extends BaseComponent {
  @Input() dataSource: GeneralLiabilityResponse;
}
